import { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { FetchingStatus, MatcherInvitationContext } from "../../shared/types";
import { updateMatcherAcceptInvitation } from "../../services/services";
import { InvitationDisplay } from "../../components/invitation";

const Accept = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [matcherInvitationContext, setMatcherInvitationContext] =
    useState<MatcherInvitationContext | null>(null);
  const [matcherInvitationAcceptFS, setMatcherInvitationAcceptFS] =
    useState<FetchingStatus>("never");

  useEffect(() => {
    updateMatcherAcceptInvitation({
      token,
      setMatcherInvitationContext,
      matcherInvitationAcceptFS,
      setMatcherInvitationAcceptFS,
    });
  }, [token]);

  const isInvitationAccepted = matcherInvitationAcceptFS === "done";
  const isLinkExpired = !token || matcherInvitationAcceptFS === "errored";

  if (
    matcherInvitationAcceptFS === "never" ||
    matcherInvitationAcceptFS === "ongoing"
  ) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <InvitationDisplay
      matcherInvitationContext={matcherInvitationContext}
      isInvitationAccepted={isInvitationAccepted}
      isLinkExpired={isLinkExpired}
    />
  );
};

export default Accept;
